import React from 'react';
import { styled } from '@mui/material/styles';
import Switch from '@mui/material/Switch';

/**
 * Interruptor animado estilo “sun / moon” que cambia entre modo claro y oscuro.
 * Se puede usar como un <Switch checked={isDark} onChange={toggle}/> normal.
 */
const ThemeModeSwitch = styled((props) => (
  <Switch focusVisibleClassName="Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 60,
  height: 32,
  padding: 7,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 2,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(28px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor: theme.palette.mode === 'dark' ? '#8796A5' : '#0d6efd',
        opacity: 1,
      },
      '& .MuiSwitch-thumb:before': {
        content: "''",
        position: 'absolute',
        width: '100%',
        height: '100%',
        left: 0,
        top: 0,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        // Moon SVG icon
        backgroundImage:
          "url('data:image/svg+xml;utf8,<svg xmlns=%22http://www.w3.org/2000/svg%22 width=%2216%22 height=%2216%22 fill=%22%23FFC107%22 viewBox=%220 0 16 16%22><path d=%22M6 0a6 6 0 0 0 0 12A6 6 0 0 1 6 0z%22/></svg>')",
      },
    },
  },
  '& .MuiSwitch-thumb': {
    backgroundColor: theme.palette.mode === 'dark' ? '#f5f5f5' : '#fff',
    width: 28,
    height: 28,
    '&:before': {
      content: "''",
      position: 'absolute',
      width: '100%',
      height: '100%',
      left: 0,
      top: 0,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      // Sun SVG icon
      backgroundImage:
        "url('data:image/svg+xml;utf8,<svg xmlns=%22http://www.w3.org/2000/svg%22 width=%2216%22 height=%2216%22 fill=%22%23FFC107%22 viewBox=%220 0 16 16%22><path d=%22M8 3.5A4.5 4.5 0 1 0 8 12.5 4.5 4.5 0 0 0 8 3.5z%22/></svg>')",
    },
  },
  '& .MuiSwitch-track': {
    borderRadius: 20 / 2,
    backgroundColor: theme.palette.mode === 'dark' ? '#2E3B4E' : '#aab4be',
    opacity: 1,
  },
}));

export default ThemeModeSwitch;
